/** @jsxRuntime classic */

export default function MultisiteSwitcher() {
  // Shadowed by gatsby-theme-cms
  return null;
}
